// composables/useUnitScale.ts
import type { PerspectiveCamera } from 'three'

export function useUnitScale(camera?: PerspectiveCamera) {
  const getVisibleSize = () => {
    
    if (!camera || !('fov' in camera)) {
      console.warn('useUnitScale: valid PerspectiveCamera is required')
      return { width: 0, height: 0, unitsPerPixelX: 0, unitsPerPixelY: 0 }
    }

    const fovRad = (camera.fov * Math.PI) / 180
    const distance = camera.position.z
    
    const height = 2 * Math.tan(fovRad / 2) * (distance )
    const width = height * camera.aspect
    
    
    const unitsPerPixelY = height / window.innerHeight
    const unitsPerPixelX = width /  window.innerWidth

    
    return {
      width,
      height,
      unitsPerPixelX,
      unitsPerPixelY,
    }
  }

  return {
    getVisibleSize,
  }
}